import fvSubassembly from "../fvSubassembly"
export default class fvCakeObj extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.save();
        if(this.borderWidth == 1){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        canvas.beginPath();
        // canvas.fillStyle = this.color;
        if(this.color=="" || this.opacity<=0){
            canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
        }else{
            var rgbArray = this.color.colorRgb(this.opacity/255);;
            canvas.fillStyle = rgbArray;//矩形填充颜色
        }
        canvas.strokeStyle = this.borderColor;
        /*
            * 采用压缩圆的方式绘制椭圆 从逆时针绘制
            * 椭圆需要切割成四分之一并且去掉三角部部分 所以绘制完成后需要重新定位
            */
        //选择width、height中的较大者作为圆的的半径参数

        var r = (this.width > this.height) ? this.width : this.height;
        var ratioX = this.width / r; //横轴缩放比率
        var ratioY = this.height / r; //纵轴缩放比率
        if(this.renderType > 0){
            canvas.beginPath();
            canvas.scale(ratioX, ratioY); //进行缩放（均匀压缩）
            switch (this.quadrant) { //所处象限
                case 0: //第一象限
                    canvas.arc(this.cx,Number(this.cy + this.height) / ratioY, r, Math.PI * 3 / 2, 0);
                    break;
                case 1: //第二象限
                    canvas.arc(Number(this.cx + this.width) / ratioX, Number(this.cy + this.height) / ratioY, r, Math.PI, Math.PI * 3 / 2);
                    break;
                case 2: //第三象限
                    canvas.arc(Number(this.cx + this.width) / ratioX,this.cy, r, Math.PI / 2, Math.PI);
                    break;
                case 3: //第四象限
                    canvas.arc(this.cx,this.cy,r, 0, Math.PI / 2);
                    break;
            }
            canvas.closePath();
            canvas.clip();
            // render.Render(this,canvas);
        }else{
            canvas.beginPath();
            canvas.scale( ratioX,ratioY); //进行缩放（均匀压缩）
            switch (this.quadrant) { //所处象限
                case 0: //第一象限
                    canvas.arc(this.cx,Number(this.cy + this.height) / ratioY, r, Math.PI * 3 / 2, 0);
                    break;
                case 1: //第二象限
                    canvas.arc(Number(this.cx + this.width) / ratioX, Number(this.cy + this.height) / ratioY, r, Math.PI, Math.PI * 3 / 2);
                    break;
                case 2: //第三象限
                    canvas.arc(Number(this.cx + this.width) / ratioX,Number(this.cy / ratioY) , r, Math.PI / 2, Math.PI);
                    break;
                case 3: //第四象限
                    canvas.arc(this.cx,Number(this.cy / ratioY), r, 0, Math.PI / 2);
                    break;
            }
            canvas.closePath();
            if(this.color && this.renderType == 0){
                if(this.opacity > 0){
                    var rgbArray = this.color.colorRgb(this.opacity/255);
                    this.color = rgbArray ;
                }else{
                    var rgbArray1 = this.color.colorRgb(0.0001);
                    this.color = rgbArray1;
                }
                canvas.fill();
            }
            canvas.stroke();                
        }
        this.Render(canvas);
        canvas.restore();
        this.executePosAnimation(canvas);
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvCakeObj.js